import { render } from "./datiBaseUser.vue?vue&type=template&id=ad7bdb72&ts=true"
import script from "./datiBaseUser.vue?vue&type=script&lang=ts"
export * from "./datiBaseUser.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\Auraclub\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__